// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Yg286","tab":"styles_tab__cxD4n","active":"styles_active__T-CBq"};